// extracted by mini-css-extract-plugin
export default {"body":"WelcomeMessage-module__body___3tAnV"};